<div class="p-2">
  <p class="text-[15px] font-bold text-[var(--base-text-dark)] mb-2">DELETE SEASON</p>
  <p class="text-[13px] text-[var(--tertiary-text)] mb-5">Are you sure you want to delete this season?</p>
  <div class="flex items-center gap-2.5">
    <button (click)="cancel()"
      class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      CANCEL
    </button>
    <button (click)="deleteSeason()"
      class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--notification-error)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">delete</span> DELETE
    </button>
  </div>
</div>
